module.exports = __webpack_public_path__ + "r-v3/img/ml_49_00_over.ff1f6852.jpg";